import { useEffect } from "react"
import { useMap } from "react-leaflet"

// Reicht die Leaflet-Map nach oben (Ersatz für ref={setMap} am früheren MapContainer).
export default function MapSetup({ onMap }) {
  const map = useMap()

  useEffect(() => {
    onMap(map)
    return () => onMap(null)
  }, [map, onMap])

  return null
}
